<template>
  <div class="picture">
    <NuxtLinkLocale role="link" :to="`/draft/influencers/?draftId=${draftId}`">
      <img
        role="img"
        :src="url"
        class="tw-h-full tw-w-full tw-rounded-full"
        alt=""
      />
    </NuxtLinkLocale>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    draftId: {
      type: Number,
      required: false,
      default: 0,
    },
    url: {
      type: String,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.picture {
  @apply tw-h-12 tw-w-12 tw-overflow-visible tw-rounded-full;

  &:hover {
    box-shadow: 0px 0px 10px #3333;
  }
}
</style>
